import _ from 'lodash';
import { ReactElement, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { StoryHistory } from 'client/utils';
import { location } from 'common/utils/url-helper';
import { parseURL, searchObjectToString } from 'common/utils/parse-url';
import { useDidMount } from 'common/components/useDidMount';
import { ClientReducerState } from 'client/reducers';
import { PARAMS } from 'common/constants';
import { CARD_SHARE_PATH, STORY_PATH } from 'client/constants/routes';

const { isPreview, isScreenshot } = location.client;

type Props = ConnectedProps<typeof connector> & RouteComponentProps & { children: ReactElement };

const RedirectController = (props: Props) => {
	const [status, setStatus] = useState(false);

	useDidMount(() => {
		if (!isPreview && !isScreenshot() && window.localStorage) {
			const { cardId, redirect } = _.pick(parseURL(window.location.search).searchObject, [
				PARAMS.CARD_ID,
				PARAMS.REDIRECT,
			]);
			const checkpoint = props.oncePerUser
				? props.checkpoint
				: new StoryHistory({ storyId: props.storyId }).lastVisitedCard;
			const { searchObject } = parseURL(window.location.href);

			const isRedirectEnabled = redirect !== '0';
			const redirectToCheckpoint = props.oncePerUser && checkpoint && checkpoint !== cardId;
			const redirectToStoryStart =
				!!cardId && ((!props.oncePerUser && isRedirectEnabled) || (props.oncePerUser && !checkpoint));

			if (redirectToCheckpoint) {
				props.history.replace({
					search: searchObjectToString({ ...searchObject, cardId: checkpoint }),
					pathname: CARD_SHARE_PATH.replace(':cardId', checkpoint),
				});
			} else if (redirectToStoryStart) {
				props.history.replace({
					search: searchObjectToString(_.omit(searchObject, ['cardId'])),
					pathname: STORY_PATH.base,
				});
			}
		}

		setStatus(true);
	});

	if (!status) return null;

	return props.children;
};

const connector = connect((state: ClientReducerState) => ({
	checkpoint: state.user.checkpoint?.cardId,
	storyId: state.story.id!,
	oncePerUser: Boolean(state.story?.storyVersions?.latest?.settings?.restrictions?.oncePerUser),
}));

export default connector(withRouter(RedirectController));
